import firebase from "firebase/compat/app";

// Add the Firebase products that you want to use
import "firebase/compat/auth";
import "firebase/compat/firestore"; 
import "firebase/storage";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getApp } from "firebase/app";




export class FirebaseAuthBackend {
  constructor(firebaseConfig: any) {
    if (firebaseConfig) {
      // Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            sessionStorage.setItem("authUser", JSON.stringify(user));
          } else {
            sessionStorage.removeItem("user");
          }
        });
      }
    }
    
    

  /**
   * Registers the user with given details
   */
  registerUser = (email: any, password: any) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          (user) => {
            resolve(firebase.auth().currentUser);
          },
          (error) => {
            reject(this._handleError(error));
          }
        );
    });
  };

   sendOTPCode = async (phoneNumber: string, isResend: boolean = false) => {
    const global = window as any;
    try {
      if (isResend || !global.recaptchaVerifier) {
        if (global.recaptchaVerifier) {
          await global.recaptchaVerifier.clear();
        }
        const elem = document.getElementById("recaptchaContainer");
        if (elem) {
          elem.innerHTML = "";
          const recaptchaDiv = document.createElement("div");
          recaptchaDiv.id = "bp-fb-ver";
          elem.append(recaptchaDiv);
        }
  
        global.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("bp-fb-ver", {
          size: "invisible",
          callback: (response: any) => {
            console.log("reCAPTCHA solved:", response);
          },
        });
      }
  
      await global.recaptchaVerifier.render();
      await global.recaptchaVerifier.verify();
  
      const confirmationResult = await firebase
        .auth()
        .signInWithPhoneNumber(phoneNumber, global.recaptchaVerifier);
      global.confirmationResult = confirmationResult;
  
      console.log("OTP sent successfully.");
    } catch (error) {
      console.error("Error during OTP process:", error);
    }
  };
  


  /**
   * Registers the user with given details
   */
  editProfileAPI = (email: any, password: any) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          (user) => {
            resolve(firebase.auth().currentUser);
          },
          (error) => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * Login user with given details
   */
  loginUser = (email: any, password: any) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          (user) => {
            resolve(firebase.auth().currentUser);
          },
          (error) => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * forget Password user with given details
   */
  forgetPassword = (email: any) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .sendPasswordResetEmail(email, {
          url:
            window.location.protocol + "//" + window.location.host + "/login",
        })
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(this._handleError(error));
        });
    });
  };
  

  uploadImage = (file: any, path: any) => {
    return new Promise<string>((resolve, reject) => {
      const app = getApp(); // Retrieve the Firebase app
      const storage = getStorage(app); // Get the storage instance
      const storageRef = ref(storage, `${path}/${Date.now()}${file.name}`); // Create a reference to the storage path

      // Upload the file
      uploadBytes(storageRef, file)
        .then((snapshot) => {
          // Get the download URL after upload is complete
          getDownloadURL(snapshot.ref)
            .then((downloadURL) => {
              resolve(downloadURL);
            })
            .catch((error) => {
              resolve('');
            });
        })
        .catch((error) => {
          resolve('');
        });
    });
  };

  /**
   * Logout the user
   */
  logout = () => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(this._handleError(error));
        });
    });
  };

  /**
   * Social Login user with given details
   */
  socialLoginUser = async (type: any) => {
    let provider: firebase.auth.AuthProvider | null = null;
    if (type === "google") {
      provider = new firebase.auth.GoogleAuthProvider();
    } else if (type === "facebook") {
      provider = new firebase.auth.FacebookAuthProvider();
    }
    if (provider) {
      try {
        const result = await firebase.auth().signInWithPopup(provider);
        const user = result.user;
        return user;
      } catch (error: any) {
        throw this._handleError(error);
      }
    }
    throw new Error(`Invalid social login type: ${type}`);
  };

  addNewUserToFirestore = (user: any) => {
    const collection = firebase.firestore().collection("users");
    const { profile } = user.additionalUserInfo;
    const details = {
      firstName: profile.given_name ? profile.given_name : profile.first_name,
      lastName: profile.family_name ? profile.family_name : profile.last_name,
      fullName: profile.name,
      email: profile.email,
      picture: profile.picture,
      createdDtm: firebase.firestore.FieldValue.serverTimestamp(),
      lastLoginTime: firebase.firestore.FieldValue.serverTimestamp(),
    };
    collection.doc(firebase.auth().currentUser!.uid).set(details);
    return { user, details };
  };

  setLoggeedInUser = (user: firebase.User) => {
    sessionStorage.setItem("authUser", JSON.stringify(user));
  };

  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = (): firebase.User | null => {
    const authUser = sessionStorage.getItem("user");
    if (!authUser) return null;
    return JSON.parse(authUser);
  };

  /**
   * Handle the error
   * @param {*} error
   */
  _handleError(error: any) {
    // var errorCode = error.code;
    var errorMessage = error.message;
    return errorMessage;
  }
}

let _fireBaseBackend: FirebaseAuthBackend | null = null;
  

/**
 * Initilize the backend
 * @param {*} config
 */
const initFirebaseBackend = (config: any): FirebaseAuthBackend => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config);
  }
  return _fireBaseBackend;
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = (): FirebaseAuthBackend | null => {
  return _fireBaseBackend;
};

let db: firebase.firestore.Firestore;

const getFirestoreInstance = () => {
  if (!db) {
    db = firebase.firestore(); // Yeh tab chalega jab app initialize ho chuki hogi
  }
  return db;
};



export { initFirebaseBackend, getFirebaseBackend , getFirestoreInstance };
